/**
 * /conditions-utilisation — Conditions d'utilisation (Phase 11).
 * Version validée juridiquement par le client.
 */
import { LegalDocument } from '@/pages/LegalDocument';
import { termsFr } from '@/lib/legal/terms_fr';
import { termsEn } from '@/lib/legal/terms_en';
import { useLang, useT } from '@/lib/i18n';

export default function Terms() {
  const { lang } = useLang();
  const t = useT();
  const doc = lang === 'en' ? termsEn : termsFr;
  return (
    <LegalDocument
      doc={doc}
      path="/conditions-utilisation"
      testid="page-terms"
      courtesyNote={lang === 'en' ? t('legal.courtesy_note') : null}
    />
  );
}
